import request from '@/utils/request';

export function getInvoices(params) {
  return request({
    method: 'get',
    url: 'internal-invoice',
    params: {
      ...params
    }
  });
}

export function createDocuments(params) {
  return request({
    method: 'post',
    url: 'internal-invoice/createDocument',
    data: {
      ...params
    },
    timeout: 120000
  });
}

export const storeExtensions = {
  actions: {
    getInvoices({ dispatch }, params) {
      return new Promise((resolve, reject) =>
        getInvoices(params)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    createDocuments({ dispatch }, params) {
      return new Promise((resolve, reject) =>
        createDocuments(params)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    }
  }
};
